export type TBreakpointNames = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export const breakpoints: { [key in TBreakpointNames]: number } = {
  xxs: 0,
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1920,
};

type BPKey<K extends TBreakpointNames> = Extract<TBreakpointNames, K>;

export function mediaQueryMin(min: BPKey<'xxs'>): '@media(min-width:0px)';
export function mediaQueryMin(min: BPKey<'xs'>): `@media(min-width:480px)`;
export function mediaQueryMin(min: BPKey<'sm'>): '@media(min-width:576px)';
export function mediaQueryMin(min: BPKey<'md'>): '@media(min-width:768px)';
export function mediaQueryMin(min: BPKey<'lg'>): '@media(min-width:992px)';
export function mediaQueryMin(min: BPKey<'xl'>): '@media(min-width:1200px)';
export function mediaQueryMin(min: BPKey<'xxl'>): '@media(min-width:1920px)';
export function mediaQueryMin(min: TBreakpointNames): string {
  return `@media(min-width:${breakpoints[min]}px)`;
}

export function mediaQueryMax(max: BPKey<'xs'>): '@media(max-width:479px)';
export function mediaQueryMax(max: BPKey<'sm'>): '@media(max-width:575px)';
export function mediaQueryMax(max: BPKey<'md'>): '@media(max-width:767px)';
export function mediaQueryMax(max: BPKey<'lg'>): '@media(max-width:991px)';
export function mediaQueryMax(max: BPKey<'xl'>): '@media(max-width:1199px)';
export function mediaQueryMax(max: BPKey<'xxl'>): '@media(max-width:1919px)';
export function mediaQueryMax(max: Exclude<TBreakpointNames, 'xxs'>): string {
  return `@media(max-width:${breakpoints[max] - 1}px)`;
}
